import type { AxiosResponse } from 'axios'
import type ResponseParserChain from '../ResponseParserChain'

import sm2 from './smCrypto/sm2'
import sm3 from './smCrypto/sm3'
import sm4 from './smCrypto/sm4'
import { Leaf7EncryptOptions } from './types'

export default class Leaf7EncryptResponseParser {
  options: Leaf7EncryptOptions
  constructor(options: Leaf7EncryptOptions) {
    this.options = options
  }

  parse(response: AxiosResponse, chain: ResponseParserChain) {
    // _s1：sm4Key
    // _s2：sm2PublicKey
    const { _s1, _s2 } = this.options
    // server 端不响应内容
    const contentType = response.headers['content-type']
    if (!contentType) {
      return
    }

    if (response.data) {
      const map = response.data
      // 取header中的签名
      let signature = response.headers['web-encrypt-sign']
      let timestamp = response.headers['web-encrypt-timestamp']

      if (map != null && signature) {
        if (map instanceof Blob) {
          return chain.doParse(response, chain)
        }
        let verifySignatureResult: boolean
        signature = signature

        const mergeStr = timestamp + map
        const sm3Str = sm3(mergeStr)
        // 验签
        try {
          verifySignatureResult = sm2._s2DOVERSIG(sm3Str, signature, _s2, { hash: true, der: true })
        } catch (e) {
          throw new Error('电子签名验证失败，接收到的响应无效')
        }
        if (!verifySignatureResult) {
          throw new Error('电子签名验证失败，接收到的响应无效')
        }

        const result = JSON.parse(sm4._s4DE(map, _s1))
        response.data = result
        return chain.doParse(response, chain)
      }
      return chain.doParse(response, chain)
    } else {
      throw new Error('未获取到请求返回数据')
    }
  }
}
